export enum SettingGroups {
  Single = "Layout Single Project View",
  Department = "Layout Department View",
  Multiple = "Layout Multi Project View",
}

export const columnKeys: (keyof SettingColumn)[] = [
  "width",
  "text",
  "type",
  "columnId",
  "field",
  "canHide",
  "hidden",
  "order",
];
export type SettingColumn = {
  width?: number;
  text: string;
  type?: string;
  columnId?: string;
  field?: string;
  canHide?: boolean;
  hidden?: boolean;
  order?: number;
};

const groups: Record<SettingGroups, SettingColumn[]> = {
  [SettingGroups.Single]: [
    {
      type: "name",
      width: 250,
      text: "TaskName",
      canHide: false,
    },
    {
      type: "startdate",
      width: 250,
      text: "StartDate",
    },
    {
      type: "enddate",
      width: 250,
      text: "EndDate",
    },
    {
      type: "duration",
      width: 100,
      text: "Duration",
    },
    {
      type: "resourceassignment",
      text: "Assigned Resources",
      width: 100,
    },
    {
      field: "RidderType",
      text: "RidderType",
    },
    {
      field: "PlanLevel",
      text: "PlanLevel",
    },
    {
      type: "milestone",
      text: "milestone",
    },
    {
      type: "showintimeline",
      text: "ShowInTimeline",
      width: 150,
    },
    {
      type: "predecessor",
      text: "Predecessors",
    },
    {
      field: "ERPWbs",
      width: 70,
      text: "WBS",
    },
    {
      type: "percentdone",
      width: 90,
      text: "% Done",
      hidden: true,
    },
    {
      type: "earlystartdate",
      width: 130,
      text: "Early Start",
      hidden: true,
    },
    {
      type: "calendar",
      width: 100,
      text: "Calendar",
      hidden: true,
    },
    {
      type: "constraintdate",
      width: 146,
      text: "Constraint Date",
      hidden: true,
    },
    {
      type: "constrainttype",
      width: 146,
      text: "Constraint Type",
      hidden: true,
    },
    {
      type: "latestartdate",
      width: 130,
      text: "Late Start",
      hidden: true,
    },
    {
      type: "schedulingmodecolumn",
      width: 100,
      text: "Scheduling Mode",
      hidden: true,
    },
    {
      type: "deadlinedate",
      width: 146,
      text: "Deadline",
      hidden: true,
    },
    {
      type: "earlyenddate",
      width: 130,
      text: "Early End",
      hidden: true,
    },
    {
      type: "lateenddate",
      width: 130,
      text: "Late End",
      hidden: true,
    },
    {
      type: "note",
      width: 150,
      text: "Note",
      field: "note",
      columnId: "note",
      hidden: true,
    },
    {
      type: "rollup",
      width: 100,
      text: "Rollup",
      hidden: true,
    },
    {
      type: "sequence",
      width: 70,
      text: "Sequence",
      hidden: true,
    },
    {
      type: "successor",
      width: 120,
      text: "Successors",
      hidden: true,
    },
    {
      type: "totalslack",
      width: 100,
      text: "Total Slack",
      hidden: true,
    },
    {
      field: "DepartmentDescription",
      text: "Department",
    },
    {
      field: "WorkActivityDescription",
      text: "Work Activity",
    },
    {
      field: "WorkActivityGroupDescription",
      text: "Work Activity Group",
    },
    {
      field: "taskBarColor",
      text: "Task color",
      width: 180,
    },
    {
      field: "LastSyncMessage",
      text: "Last sync message",
      width: 250,
    },
    {
      field: "PlannedHours",
      type: "effort",
      text: "Planned Hours",
    },
    {
      field: "LastSyncMessageType",
      text: "Last sync type",
      width: 100,
    },
    {
      columnId: "OrderNumber",
      field: "OrderNumber",
      width: 130,
      text: "OrderNumber",
      hidden: false,
    },
    {
      columnId: "prefix",
      field: "prefix",
      text: "Code",
      hidden: false,
    },  
    {
      columnId: "CustomerName",
      field: "CustomerName",
      width: 130,
      text: "CustomerName",
      hidden: false,
    },
  ],
  [SettingGroups.Department]: [
    {
      type: "name",
      text: "TaskName",
      width: 250,
      canHide: false,
    },
    {
      type: "startdate",
      text: "StartDate",
      width: 250,
    },
    {
      type: "enddate",
      text: "EndDate",
      width: 250,
    },
    {
      type: "schedulingmodecolumn",
      text: "Scheduling Mode",
    },
    {
      type: "duration",
      text: "Duration",
    },
    {
      type: "resourceassignment",
      text: "Assigned Resources",
      width: 100,
    },
    {
      type: "effort",
      text: "Planned Hours",
    },
    {
      field: "RidderType",
      text: "RidderType",
    },
    {
      field: "PlanLevel",
      text: "PlanLevel",
    },
    {
      field: "milestone",
      text: "milestone",
    },
    {
      type: "predecessor",
      text: "Predecessors",
    },
    {
      field: "DepartmentDescription",
      text: "Department",
    },
    {
      field: "WorkActivityDescription",
      text: "Work Activity",
    },
    {
      field: "WorkActivityGroupDescription",
      text: "Work Activity Group",
    },
    {
      field: "taskBarColor",
      text: "Task color",
      width: 180,
    },
    {
      field: "ERPWbs",
      width: 70,
      text: "WBS",
    },
    {
      type: "deadlinedate",
      width: 146,
      text: "Deadline",
      hidden: true,
    },
    {
      type: "earlystartdate",
      width: 130,
      text: "Early Start",
      hidden: true,
    },
    {
      type: "latestartdate",
      width: 130,
      text: "Late Start",
      hidden: true,
    },
    {
      type: "earlyenddate",
      width: 130,
      text: "Early End",
      hidden: true,
    },
    {
      type: "lateenddate",
      width: 130,
      text: "Late End",
      hidden: true,
    },
    {
      width: 150,
      text: "Note",
      type: "note",
      columnId: "note",
      field: "note",
    },
    {
      type: "percentdone",
      columnId: "percentdone",
      width: 90,
      text: "% Done",
      order: 6,
    },
    {
      columnId: "OrderNumber",
      field: "OrderNumber",
      width: 130,
      text: "Order number",
      hidden: false,
    },
    {
      columnId: "prefix",
      field: "prefix",
      text: "Code",
      hidden: false,
    },  
    {
      columnId: "ProjectNumber",
      field: "projectNumber",
      width: 130,
      text: "Project number",
      hidden: false,
    },
    {
      columnId: "CustomerName",
      field: "CustomerName",
      width: 130,
      text: "CustomerName",
      hidden: false,
    },
  ],
  [SettingGroups.Multiple]: [
    {
      type: "name",
      text: "TaskName",
      canHide: false,
      order: 7,
      width: 283,
    },
    {
      type: "percentdone",
      width: 90,
      text: "% Done",
      order: 6,
    },
    {
      type: "rollup",
      text: "Rollup",
      width: 76,
      order: 5,
    },
    {
      type: "startdate",
      width: 140,
      order: 4,
      text: "StartDate",
    },
    {
      type: "enddate",
      width: 124,
      order: 3,
      text: "EndDate",
    },
    {
      type: "effort",
      order: 2,
      width: 124,
      text: "Planned Hours",
    },
    {
      type: "duration",
      text: "Duration",
      width: 140,
      order: 8,
    },    
    {
      type: "showintimeline",
      text: "ShowInTimeline",
      order: 1,
      width: 122,
    },
    {
      width: 150,
      text: "Note",
      type: "note",
      columnId: "note",
      field: "note",
    },
    {
      text: "Project manager",
      field: "projectManager",
      columnId: "projectManager",
      width: 130,
      order: -1,
    },
    {
      type: "resourceassignment",
      text: "Assigned Resources",
      columnId: "resourceassignment",
      width: 130,
      order: -1,
    },
    {
      type: "earlystartdate",
      columnId : "earlystartdate",
      width: 130,
      text: "Early Start",
      hidden: true,
    },
    {
      type: "lateenddate",
      columnId: "lateenddate",
      width: 130,
      text: "Late End",
      hidden: true,
    },
    {
      columnId: "projectnumber",
      width: 130,
      text: "Project number",
      hidden: true,
    },
    {
      columnId: "CustomerName",
      width: 130,
      text: "CustomerName",
      hidden: false,
    },  
    {
      columnId: "OrderNumber",
      field: "OrderNumber",
      width: 130,
      text: "Order number",
      hidden: false,
    },
    {
      columnId: "prefix",
      field: "prefix",
      text: "Code",
      hidden: false,
    },  
    {
      columnId: "probabilityOfSale",
      field: "probabilityOfSale",
      width: 130,
      text: "Probability of sale",
      hidden: false,
    }
  ],
};

function compare(a: SettingColumn, b: SettingColumn) {
  if (a.text < b.text) {
    return -1;
  }
  if (a.text > b.text) {
    return 1;
  }
  return 0;
}
groups["Layout Department View"].sort(compare);
groups["Layout Single Project View"].sort(compare);
groups["Layout Multi Project View"].sort(compare);

export function getColumnId(column: SettingColumn) {
  return column.columnId || column.type || column.field || "";
}

export { groups };
